export default __webpack_public_path__ + "9f3e2075bc9411291f50d30306b5d342.png";